import React, { useState, useEffect } from "react";
import {
    Card,
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
    Divider
} from "@mui/material";
import signInBanner1 from '../../../assets/signin_banner.jpg';
import signInBanner2 from '../../../assets/signin_banner1.jpeg';
import signInBanner3 from '../../../assets/signin_banner-2.jpeg';
import { useNavigate } from "react-router-dom";
import '../../../css/App.css';
import Header from '../../../components/header.tsx';
import Footer from '../../../components/footer.tsx';

/* const countries = [
    { code: "+91", label: "India" },
    { code: "+1", label: "USA" },
    { code: "+44", label: "UK" },
    // Add more as needed
]; */

const PasswordAssistance = () => {

    const navigate = useNavigate();
    const [useMobileLogin, setUseMobileLogin] = useState(false);
    const sidebanner = [signInBanner1, signInBanner2, signInBanner3];
    const [bannercurrentIndex, setBannerCurrentIndex] = useState(0);


    useEffect(() => {
        const interval = setInterval(() => {
            setBannerCurrentIndex((prev) => (prev + 1) % sidebanner.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    /* const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [mobileNumber, setMobileNumber] = useState("");
    const [countryCode, setCountryCode] = useState("+91");

    const handleSubmit = () => {
        if (useMobileLogin) {
            console.log("Logging in with:", countryCode + mobileNumber);
        } else {
            console.log("Logging in with:", email, password);
        }
    }; */

    return (
        <>
            {/* header */}
            <Header />
            {/* end header */}

            {/* body */}
            <Box className="primary-box" >
                {/* Left side with image ads */}
                <Box
                    className="secondary-box"
                    sx={{
                        padding: 2,
                    }}
                    display={{
                        xs: 'none',
                        md: 'block'
                    }}
                >
                    <img
                        src={sidebanner[bannercurrentIndex]}
                        alt="Ad Banner"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "cover",
                            width: '100%'
                        }}
                    />
                </Box>

                {/* password assistance card */}
                <Box className="secondary-box" sx={{ flexDirection: 'column' }}>
                    <Card className="auth-card"
                        sx={{
                            p: 3
                        }}
                    >
                        {/* Logo */}
                        <Box className="auth-logo"
                            sx={{
                                mx: "auto",
                                mb: 2,
                            }}
                        >
                            <Typography
                                sx={{ fontSize: "40px", color: "#fff", fontWeight: "bold" }}
                            >
                                F5
                            </Typography>
                        </Box>

                        {/* Title */}
                        <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, mb: 2, textAlign: "left" }}
                        >
                            Password Assistace
                        </Typography>
                        <Typography
                            sx={{ mb: 2, textAlign: "left", fontSize: '14px' }}
                        >
                            Enter the email address or mobile phone number associated with your FortuneFive account.
                        </Typography>

                        <>
                            {/* Email Field */}
                            <TextField
                                fullWidth
                                type="text"
                                label="Email or Phone Number"
                                /* value={email}
                                onChange={(e) => setEmail(e.target.value)} */
                                sx={{ mb: 2 }}
                                size="small"
                                placeholder="Enter email or phone number"
                            />
                        </>

                        {/* Submit Button */}
                        <Button
                            fullWidth
                            variant="contained"
                            // onClick={handleSubmit}
                            sx={{
                                textTransform: "none",
                                fontWeight: "bold",
                                backgroundColor: "#C32032",
                                mb: 1,
                            }}
                        >
                            Continue
                        </Button>
                    </Card>
                    {/* <Divider sx={{ my: 2, width: '100%' }} />

                    <Box
                        sx={{
                            width: '350px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            textAlign: 'center',
                            fontSize: '13px',
                            color: '#C32032',
                        }}
                    >
                        <Typography sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            cursor: 'pointer'
                        }}>Conditions of use</Typography>
                        <Typography sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            cursor: 'pointer'
                        }}>Privacy Policy</Typography>
                        <Typography sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            cursor: 'pointer'
                        }}>Help</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: '350px',
                            display: 'flex',
                            justifyContent: 'center',
                            textAlign: 'center',
                            fontSize: '13px',
                            color: '#666',
                            mt: 2
                        }}
                    >
                        <Typography>©2025, FortuneFive.com</Typography>
                    </Box> */}
                </Box>
            </Box>
            {/* end body */}

            {/* footer */}
            <Footer />
            {/* end footer */}
        </>
    );
};

export default PasswordAssistance;